import HeaderPortal from "components/portal/header-portal";
import { FormLabel } from "components/form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Form } from "react-crud-form";
import IndustryInput from "components/industry/input";
import NdaInput from "components/nda/input";
import React from "react";
import { Textarea } from "ui/components/textarea";
import { Button } from "ui/index";
import { useParams } from "react-router-dom";
import { useClientContextForm } from "./useClientContextForm";
import { clientContextSchema } from "./schema";
import SubIndustryCombobox from "components/directus/combobox/sub-industry";

const ClientContextForm = () => {
  const { casestudyId } = useParams();

  const { form, requiredFields, handleCreate, handleRead, handleUpdate } =
    useClientContextForm({ casestudyId });

  return (
    <div className="flex-1 max-w-md p-4">
      <Form
        form={form}
        create={handleCreate}
        read={handleRead}
        update={handleUpdate}
        itemId={casestudyId || "+"}
        schema={clientContextSchema}
      >
        {({
          isCreating,
          createItem,
          isNewItem,
          isUpdating,
          updateItem,
          isDirty,
        }) => {
          return (
            <div className="space-y-6">
              <FormField
                control={form.control}
                name="nda_level"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel required={requiredFields.includes(field.name)}>
                      NDA Level
                    </FormLabel>
                    <NdaInput {...field} />
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="industry"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel required={requiredFields.includes(field.name)}>
                      Industry
                    </FormLabel>
                    <IndustryInput
                      value={field.value}
                      onChange={(val) => {
                        form.setValue("sub_industry", "");
                        field.onChange(val);
                      }}
                      onBlur={field.onBlur}
                      name={field.name}
                      ref={field.ref}
                    />
                    <FormMessage />
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="sub_industry"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel required={requiredFields.includes(field.name)}>
                      Sub Industry
                    </FormLabel>
                    <SubIndustryCombobox
                      className="max-w-full"
                      hideLabel={true}
                      disabled={!form.watch("industry")}
                      {...field}
                      filter={{ type: { _eq: form.watch("industry") } }}
                    />
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="client_requirement"
                render={({ field }) => {
                  return (
                    <FormItem>
                      <FormLabel required={requiredFields.includes(field.name)}>
                        Client Requirement
                      </FormLabel>
                      <Textarea {...field} className="min-h-32" />
                      <FormMessage />
                    </FormItem>
                  );
                }}
              />

              {/* Portal buttons similar to TimesheetLog */}
              <HeaderPortal>
                {isNewItem ? (
                  <Button
                    variant="default"
                    isLoading={isCreating}
                    onClick={createItem}
                  >
                    Save
                  </Button>
                ) : (
                  <Button
                    variant="default"
                    isLoading={isUpdating}
                    disabled={!isDirty}
                    onClick={updateItem}
                  >
                    Save
                  </Button>
                )}
              </HeaderPortal>
            </div>
          );
        }}
      </Form>
    </div>
  );
};

export default ClientContextForm;
